import { render, staticRenderFns } from "./StoriesView.vue?vue&type=template&id=2c1d0966&scoped=true&"
import script from "./StoriesView.vue?vue&type=script&lang=ts&"
export * from "./StoriesView.vue?vue&type=script&lang=ts&"
import style0 from "./StoriesView.vue?vue&type=style&index=0&id=2c1d0966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d0966",
  null
  
)

export default component.exports